module.exports = __webpack_public_path__ + "img/flow4.4d9a85a2.png";